<template>
  <div
    v-for="paymentOption in paymentMethods"
    :key="paymentOption.id"
    class="col-span-full rounded-lg border p-4"
  >
    <RadioGroup v-model="selectedPaymentMethod" name="payment-method">
      <Radio :value="paymentOption.id">
        <div class="flex w-full flex-wrap gap-5 hyphens-auto sm:flex-nowrap">
          <div v-if="paymentOption.description" class="flex flex-col gap-1">
            {{ paymentOption.name }}
            <Tint class="text-sm">{{ paymentOption.description }}</Tint>
          </div>
          <template v-else>{{ paymentOption.name }}</template>
          <img
            v-if="paymentOption?.media?.url"
            :alt="paymentOption.name"
            :src="paymentOption.media?.url"
            class="ml-auto h-8"
          />
        </div>
      </Radio>
    </RadioGroup>
    <div
      v-if="paymentOption.customFields?.mollie_payment_method_name === 'creditcard'"
      :class="{ hidden: !creditCardSelected }"
      class="mt-4"
    >
      <ShopwareFrontendsCreditCard ref="creditCardComponent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PaymentMethod } from "@shopware-pwa/types";
import { Tint } from "~/components/clarity-ui/Tint";
import { Radio } from "~/components/clarity-ui/Radio";
import { RadioGroup } from "~/components/clarity-ui/Radio/RadioGroup";
import ShopwareFrontendsCreditCard from "~/templates/components/shop/checkout/ShopwareFrontendsCreditCard.vue";

export interface PaymentMethodSelectionProps {
  paymentMethods?: PaymentMethod[];
}

const props = defineProps<PaymentMethodSelectionProps>();
const selectedPaymentMethod = defineModel<string>("selectedPaymentMethod");

const emit = defineEmits(["change"]);

const creditCardComponent = ref(null);

const selectedOption = computed(() =>
  props.paymentMethods?.find((method: PaymentMethod) => method.id === selectedPaymentMethod.value),
);

const creditCardSelected = computed(
  () => selectedOption.value?.customFields?.mollie_payment_method_name === "creditcard",
);

watch(selectedPaymentMethod, () => {
  emit("change", selectedPaymentMethod.value);
});

const validate = async () => {
  let valid = !!selectedPaymentMethod.value;
  if (creditCardSelected.value && creditCardComponent.value?.[0]) {
    const token = await creditCardComponent.value?.[0]?.checkFieldsAndSubmitToken?.();
    valid = !!token;
  }

  return valid;
};

defineExpose({ validate });
</script>
